export interface ApiError {
  message: string;
  status?: number;
  code?: string;
  details?: Record<string, unknown>;
}

export interface AuthError extends Error {
  code: 'AUTH_FAILED' | 'TOKEN_EXPIRED' | 'NETWORK_ERROR' | 'INVALID_CREDENTIALS' | 'USER_CANCELLED' | 'POPUP_BLOCKED';
  details?: Record<string, unknown>;
}

export interface MsalError extends Error {
  errorCode?: string;
  errorMessage?: string;
  subError?: string;
}

export interface NetworkError extends Error {
  status?: number;
  statusText?: string;
  url?: string;
}

export function createAuthError(message: string, code: AuthError['code'], details?: Record<string, unknown>): AuthError {
  const error = new Error(message) as AuthError;
  error.code = code;
  error.details = details;
  return error;
}

export function createApiError(message: string, status?: number, code?: string): ApiError {
  return {
    message,
    status,
    code,
  };
}

export function isAuthError(error: unknown): error is AuthError {
  return error instanceof Error && 'code' in error;
}

export function isApiError(error: unknown): error is ApiError {
  return typeof error === 'object' && error !== null && 'message' in error;
}